import * as React from 'react';
export var TabPanel = function (props) {
    var ariaLabelledby = props.ariaLabelledby, panelId = props.panelId, children = props.children, className = props.className;
    return (React.createElement("div", { role: "tabpanel", tabIndex: 0, "aria-labelledby": ariaLabelledby, id: panelId, className: className }, children));
};
export default TabPanel;
//# sourceMappingURL=TabPanel.js.map